import AdminLayout from "../components/AdminLayout";
import TableCategory from "../components/TableCategory";

const CategoryAdmin = () => {
  return (
    <AdminLayout title="Categories" stats="default">
      <TableCategory />
    </AdminLayout>
  );
};

export default CategoryAdmin;
